/**
 * Appends From, Until, and DateFilterType query params for statistics APIs.
 * DateFilterType is always sent (defaults to Redemption).
 * Until is sent as the selected date at 23:59:59 so that day is included.
 */

const HAS_TIME = /\d{1,2}:\d{2}(:\d{2})?/;

/**
 * Converts a date-only Until value into an inclusive end-of-day datetime.
 * Same From and To dates then cover that full calendar day.
 */
export function toInclusiveUntil(endDate) {
  if (!endDate) {
    return endDate;
  }
  const value = String(endDate).trim();
  if (!value || HAS_TIME.test(value)) {
    return value;
  }
  return `${value} 23:59:59`;
}

export function appendDateParams(params, dateRange) {
  if (dateRange?.startDate) {
    params.append('From', dateRange.startDate);
  }
  if (dateRange?.endDate) {
    params.append('Until', toInclusiveUntil(dateRange.endDate));
  }
  params.append('DateFilterType', dateRange?.dateFilterType || 'Redemption');
}

/**
 * Builds a query string (with leading ?) from a dateRange, or empty string if only defaults.
 */
export function buildDateQueryString(dateRange) {
  const params = new URLSearchParams();
  appendDateParams(params, dateRange);
  const qs = params.toString();
  return qs ? `?${qs}` : '';
}
